import { module as BaseModule } from 'modujs'
import Swiper from 'swiper'
import { Navigation } from 'swiper/modules'

export default class extends BaseModule {
  constructor(m) {
    super(m)
  }

  init() {
    const sliders = this.el.querySelectorAll('[data-slider]')
    const prevEl = this.el.querySelector('[data-slider-prev]')
    const nextEl = this.el.querySelector('[data-slider-next]')

    // console.log(sliders, prevEl, nextEl)

    const breakpoints = this.el.getAttribute('data-slider-breakpoints') !== null
      ? JSON.parse(this.el.getAttribute('data-slider-breakpoints'))
      : {}

    const loop = this.el.getAttribute('data-slider-loop') === '1'
      || this.el.getAttribute('data-slider-loop') === null

    sliders.forEach((slider) => {
      const swiper = new Swiper(slider, {
        modules: [Navigation],
        speed: 400,
        navigation: {
          nextEl,
          prevEl,
        },
        loop,
        draggable: true,
        breakpoints,
      })

      slider.classList.remove('opacity-0')
    })
  }
}
